<div class="label-wrapper">
  <ng-content select="[prefix]"></ng-content>
  <input
    type="radio"
    [id]="id"
    [name]="name"
    [value]="id"
    [(ngModel)]="selectedId"
    (change)="radioChangeHandler(id!)"
  />
  <ng-content select="[inside]"></ng-content>
  <label [for]="id">
    <span class="label">{{ label }}</span>
  </label>
  <ng-content select="[suffix]"></ng-content>
</div>
